import { Link } from 'react-scroll';
import styled from 'styled-components';
import {
  color,
  fontFamily,
  fontSize,
  fontWeight,
  screen,
  spacing
} from '../../../theme';

export const StyledHeroInfoData = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: ${spacing('sm')};
  margin-bottom: ${spacing('md')};
  padding-bottom: ${spacing('xs')};
  padding-top: ${spacing('md')};
  border-top: 1px solid ${color('midnight_200')};

  @media (min-width: ${screen('md')}) {
    border-top: 1px solid rgba(255, 255, 255, 0.5);
    border-bottom: 1px solid rgba(255, 255, 255, 0.5);
  }

  @media (min-width: ${screen('lg')}) {
    align-items: flex-start;
  }
`;

export const StyledHeroInfoDataItems = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;

  @media (min-width: ${screen('md')}) {
    flex-direction: row;
    align-items: flex-start;
  }
`;

export const StyledHeroInfoDataItemValue = styled(Link)`
  font-family: ${fontFamily('display')};
  font-weight: ${fontWeight('light')};
  font-size: ${fontSize('xl4')};
  text-transform: uppercase;
  color: ${color('link_inverse')};

  &:hover {
    color: ${color('link_inverse_hover')};
  }

  &:active {
    color: ${color('link_inverse_active')};
  }

  strong {
    font-weight: ${fontWeight('semiBold')};
  }
  span {
    color: ${color('text_subtle_inverse')};

    &.extra-value {
      color: ${color('text_default_inverse')};
    }
  }
`;

export const StyledHeroInfoDataItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${spacing('md')};
  margin-right: ${spacing('md')};

  @media (min-width: ${screen('md')}) {
    &:first-child {
      margin-left: 0;
    }
  }

  &.is-salary {
    @media (max-width: ${screen('mdMax')}) {
      margin-bottom: ${spacing('lg')};
      ${StyledHeroInfoDataItemValue} {
        font-size: ${fontSize('xl6')};
      }
    }
  }
`;

export const StyledHeroInfoDataItemGroup = styled.div`
  display: flex;
  justify-content: center;
  margin-left: 0;
  width: 100%;
  align-items: center;

  @media (min-width: ${screen('md')}) {
    width: unset;
    margin-left: ${spacing('md')};
    justify-content: flex-start;
  }
`;

export const StyledHeroInfoDataItemTitle = styled.span`
  color: ${color('text_white')};
  font-weight: ${fontWeight('black')};
  font-size: ${fontSize('sm')};
  text-transform: uppercase;
`;

export const StyledHeroInfoDataItemSeparator = styled.span`
  align-self: center;
  font-family: ${fontFamily('serif')};
  font-style: italic;
  font-size: ${fontSize('xl2')};
  color: ${color('text_subtle_inverse')};
`;

export const StyledHeroInfoDataBadges = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin-top: ${spacing('md')};

  @media (min-width: ${screen('md')}) {
    justify-content: flex-start;
  }

  > * {
    margin-bottom: ${spacing('xs')};
  }
  > *:not(:last-child) {
    margin-right: ${spacing('xs')};
  }
`;
